export default {
    methods: {
        showLoading: function (msg) {
            return this.$toast({
                type: 'loading',
                duration: 0
            })
        },
        showTip: function (msg, type) {
            return this.$toast({
                duration: 3500,
                message: msg
            })
        },
        showErrorTip: function (msg) {
            return this.$dialog({
                title: '错误',
                message: msg
            })
        },
        showSuccessTip: function (msg) {
            return this.$toast({
                type: 'success',
                duration: 3500,
                message: msg
            })
        }
    }
}
